import SessionEspirationView from '../SessionExpirationView/SessionExpirationView';
import { InvertStepMap } from '../../../utils/StepsMap';

export const sessionView = (timerFinish: any, count: any, sessionSubscription: any, showSessionExpired = false) => {
  if (!timerFinish && !showSessionExpired) {
    return (
      <SessionEspirationView
        sessionExpired={false}
        sessionExpiring={true}
        missingSeconds={count}
        subscription={sessionSubscription}
      />
    );
  } else {
    return <SessionEspirationView sessionExpired={true} sessionExpiring={true} subscription={sessionSubscription} />;
  }
};

export const dismantledStepsConditions = (actualStep: string) => {
  if (
    actualStep !== InvertStepMap.contatti &&
    actualStep !== InvertStepMap['collega-banche'] &&
    actualStep !== InvertStepMap['valuta-proposta'] &&
    actualStep !== InvertStepMap['compila-la-normativa'] &&
    actualStep !== InvertStepMap['fatti-riconoscere']
  ) {
    return true;
  }
  return false;
};
